<template >
  <div>
    <div class="main_form">
      <!-- 查询表单 start-->
      <el-form :inline="true" :model="queryModel" size="small" ref="queryForm">
        <el-form-item class="search_form_item" prop="userId">
          <el-input v-model.trim="queryModel.userId" :placeholder="$t('m.live_ID')" clearable></el-input>
        </el-form-item>
        <el-form-item class="search_form_item" prop="status">
          <el-select v-model="queryModel.status" :placeholder="$t('m.audit_status')" clearable>
            <el-option :value="5" :label="$t('m.pending_review')"></el-option>
            <el-option :value="6" :label="$t('m.approved')"></el-option>
            <el-option :value="7" :label="$t('m.not_approved')"></el-option>
            <el-option :value="15" :label="$t('m.withdrawn')"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-col :span="11">
            <el-date-picker v-model="queryModel.applyStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('m.apply_time')" style="width:100%"></el-date-picker>
          </el-col>
          <el-col class="coldiv" :span="1">~</el-col>
          <el-col :span="11">
            <el-date-picker v-model="queryModel.applyEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('m.apply_time')" style="width:100%"></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper">
        <el-button @click="onQueryBtnClick" type="primary" size="small">{{$t('m.search')}}</el-button>
        <el-button type="text" size="mini"  @click="resetForm">{{$t('m.reset')}}</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="main_table">
      <el-table :data="tableData" border style="width: 100%;margin-bottom: 10px;" v-loading="loading.table" ref="tableOrder" :element-loading-text="''"
        element-loading-spinner="el-icon-loading" >
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="userId" :label="$t('m.live_ID')"></el-table-column>
        <el-table-column prop="userName" :label="$t('m.sereamer_nickname')">
          <template slot-scope="scope">
            <el-button type="text" @click="getUnionDetail(scope.row)">{{scope.row.userName}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="reqComplain" :label="$t('m.termination_reason')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="fileList" :label="$t('m.img_material')">
          <template slot-scope="scope">
            <img :src="scope.row.fileList[0].url" class="img-thumb" @click="showPicPreviewDialog(scope.row.fileList)"
            v-if="scope.row.fileList&&scope.row.fileList.length>0 && scope.row.fileList[0].url">
          </template>
        </el-table-column>
        <el-table-column prop="cancelTime" :label="$t('m.apply_time')"></el-table-column>
        <el-table-column prop="status" :label="$t('m.audit_status')">
          <template slot-scope="scope">
            <el-tag size="mini" type="warning" v-if="scope.row.status ===5">{{$t('m.pending_review')}}</el-tag>
            <el-tag size="mini" type="success" v-if="scope.row.status ===6">{{$t('m.approved')}}</el-tag>
            <el-tag size="mini" type="danger" v-if="scope.row.status ===7">{{$t('m.not_approved')}}</el-tag>
            <el-tag size="mini" type="info" v-if="scope.row.status ===15">{{$t('m.withdrawn')}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="approverName" :label="$t('m.approver')">
          <template slot-scope="scope">
            <span v-if="scope.row.status !==5">{{scope.row.approverName}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('m.oper')">
          <template slot-scope="scope">
            <div class="oper-group-btn">
              <span class="fc-color-main" @click="passApplication(scope.row)" v-if="scope.row.status ===5">{{$t('m.pass')}}</span>
              <span class="fc-color-main" @click="rejectApplication(scope.row)" v-if="scope.row.status ===5">{{$t('m.refused')}}</span>
              <span class="fc-color-main" @click="openAuditingLogDialog(scope.row)" >{{$t('m.audit_trail')}}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @size-change="onSizeChange" @current-change="onCurrentPageChange" :current-page="pager.page"
        :page-sizes="[10, 20, 30, 100, 300, 500]" :page-size="pager.limit" small layout="total, sizes, prev, pager, next, jumper"
        :total="pager.total" :pager-count="5"></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :visible.sync="dialog.reject.show" :title="$t('m.leave_agency_apply')" :close-on-click-modal="false" :append-to-body="true" @close="$refs.rejectForm.resetFields()">
      <el-form :model="dialog.reject.model" :rules="dialog.reject.rules" size="small" ref="rejectForm" label-position="left">
        
          <!-- <span>拒绝主播【{{dialog.reject.model.userName}}】的退会申请！</span> -->
       
        <el-form-item prop="refuseReason" :label="$t('m.rejection_reason')+':'" label-width="100px">
          <!-- 请输入拒绝理由,最多50字 -->
          <el-input v-model.trim="dialog.reject.model.refuseReason" type="textarea" :placeholder="$t('m.rejection_reason')" maxlength="50"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog.reject.show = false" size="small">{{$t('m.cancel')}}</el-button>
        <el-button type="primary" @click="doEdit" size="small" :loading="dialog.reject.btnLoading">{{$t('m.Confirm')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialog.picture.show" :title="$t('m.preview')+':'" :close-on-click-modal="false" :append-to-body="true" @close="resetInfoForm">
      <div v-loading="dialog.picture.loading">
        <el-carousel :autoplay="false" indicator-position="none" arrow="always">
          <el-carousel-item v-for="(item, index) in dialog.picture.fileList" :key="index">
            <img :src="item.url" v-if="item.type ===2 || item.type === 4 || item.type === 3" class="img-preview">
            <video :src="item.url" v-if="item.type ===0 || item.type ===1" controls="controls" type="video/mp4" class="img-preview" playsinline webkit-playsinline></video>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
    <anchor-cooperation-log-dialog  @done="query" ref="anchorDetailDialog"></anchor-cooperation-log-dialog>
    <anchor-auditing-log-dialog  @done="query" ref="anchorAuditingDialog"></anchor-auditing-log-dialog>
  </div>
</template>
<script>
import {
  getGuildApprovalList,
  editQuildApproval,
  inviteLogExportData
} from '../../api/anchor/management';
import anchorCooperationLogDialog from './dialogs/anchorCooperationLogDialog';
import anchorAuditingLogDialog from './dialogs/anchorAuditingLogDialog';
let queryModelEmpty={
  userId: null,
  userName: null,
  status: null,
  applyStartTime: null,
  applyEndTime: null
}
export default {
  components: {
    'anchor-cooperation-log-dialog': anchorCooperationLogDialog,
    'anchor-auditing-log-dialog': anchorAuditingLogDialog,
  },
  data () {
    return {
      searchBtnTrue: true, // 在生命周期中的列表数据加载完之前搜索按钮是不可点击状态
      guildList: [],
      liverList: [],
      n: 0,
      queryModel: JSON.parse(JSON.stringify(queryModelEmpty)),
      loading: {
        table: true
      },
      pager: {
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      dialog: {
        reject: {
          rules: {
            refuseReason: [
              {required: true, trigger: 'change', message: this.$t('m.no_data')}
            ]
          },
          show: false,
          btnLoading: false,
          model: {
            id: null,
            userName: null,
            refuseReason: null,
            operation: 0
          },
        },
        picture: {
          show: false,
          fileList: []
        },
      },
    }
  },
  methods: {
    //重置参数
    resetForm(){
      this.queryModel=JSON.parse(JSON.stringify(queryModelEmpty));
    },
    reduceBut(){
      if(this.dialog.picture.fileList && this.dialog.picture.fileList.length>1){
        if(this.n > 0){
           this.n--;
        }
      }

    },
    addBut(){
      if(this.dialog.picture.fileList && this.dialog.picture.fileList.length>1){
        if(this.n < this.dialog.picture.fileList.length-1)
        this.n++;
      }
    },
    resetInfoForm() {
      this.dialog.picture.fileList = [];
      // this.n = 0;
    },
    showPicPreviewDialog(row) {
      console.log(row);
      this.dialog.picture.fileList = row;
      this.dialog.picture.show = true;
    },
    activeInputElement() {
      document.activeElement.blur();
      this.$nextTick(() => {
          let inputTime = document.querySelectorAll('.el-input__inner')
          inputTime.forEach(item => {
            item.addEventListener('focus', () => {
              document.activeElement.blur()
            })
          })
        })
    },
    //查看签约记录
    getUnionDetail(row) {
      this.$refs.anchorDetailDialog.showDialog(row);
    },
    rejectApplication(row) {
      this.dialog.reject.model.id = row.id;
      this.dialog.reject.model.userName = row.userName;
      // this.dialog.reject.model.refuseReason = '申请理由不充分，可参照《签约主播协议书》，修改后再次申请。';
      this.dialog.reject.show =true;
    },
    openAuditingLogDialog(row) {
      this.$refs.anchorAuditingDialog.showDialog(row);
    },
    doEdit() {
      this.$refs.rejectForm.validate(valid =>{
        if(valid) {
         editQuildApproval(this.dialog.reject.model)
         .then(({data}) => {
            if(data.data.detail === 0) {
              this.$message.success(this.$t('m.rejected'));
              this.dialog.reject.show = false;
              this.getTableData();
            }else {
              this.$alert(this.$t('m.oper_failed'),this.$t('m.tip'),{
                confirmButtonText: this.$t('m.i_got_it'),
                callback: action => {
                  this.dialog.reject.show = false;
                  this.getTableData();
                }
              })
            }            
            
         })
         .catch(() =>{})
        }else {
          return false;
        }
      })
    },
    passApplication(row) {
      // 同意主播【${row.userName}】退会申请~
      this.$confirm(this.$t('m.review_pass')+'?',this.$t('m.leave_agency_apply'),{
        type:'success'
      })
      .then(() =>{
        let model = {
          id: row.id,
          operation: 1,
          refuseReason: null
        }
        editQuildApproval(model)
        .then(({data}) => {
          if(data.data.detail === 0) {
             this.$message.success(this.$t('m.oper_success'));
             this.getTableData();
           }else {
             this.$alert(this.$t('m.oper_failed'),this.$t('m.tip'),{
               confirmButtonText: this.$t('m.i_got_it'),
               callback:()=>{
                this.getTableData();
               }
             })
           }
        })
        .catch(() =>{})
      })
      .catch(() =>{
        this.getTableData();
      })
    },
    onQueryBtnClick() {
      this.pager.page = 1;
      this.$refs.tableOrder.clearSort();
      this.query();
    },
    query() {
      this.loading.table = true;
      this.getTableData();
    },
    onSizeChange(size) {
      this.pager.limit = size;
      this.query();
    },
    onCurrentPageChange(page) {
      this.pager.page = page;
      this.query();
    },
    getTableData() {
      // 显示表格loading
      this.loading.table = true;
      getGuildApprovalList({
        query: this.queryModel,
        pager: this.pager,
        sorter: this.sorter
      })
        .then(({ data }) => {
          this.tableData = data.data.list;
          this.pager.total = data.data.total;
          // 取消loading状态
          this.loading.table = false;
          this.searchBtnTrue = false;
        })
        .catch(error => {
          this.loading.table = false;
        });
    },
  },
  created() {
    this.getTableData();
  }
}
</script>
<style scoped>
.btn_style .el-button--small{
  padding: 20px 10px;
  font-size: 20px;
}
.btn_style .el-button--info {
  color: #909399;
  background-color: #fff;
  border-color: #fff;
}
.btn_style .el-button--info:hover {
  color: #909399;
  background-color: #e0e5ee;
  border-color: #e0e5ee;
}
.coldiv{
  text-align: center;
}
.oper-group-btn span{
   display: inline-block;
   padding: 0 5px;
   cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/anchor/quitGuildApprovalPage.vue